import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'phoneNumber'})
export class PhoneNumberPipe implements PipeTransform {

  constructor() {
  }

  transform(value: string, ...args: unknown[]): string {
    if (!value) {
      return null;
    }
    const result = value.replace(/\D+/g, '');
    return result;
  }
}
